import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { GenericValue } from 'hisng';

import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { StringUtils } from 'app/fs/res/common/utils/string-utils';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { ResearchInfrastructureUsage } from 'app/fs/res/research-infrastructure/model/research-infrastructure-classes';

@Component( {
    selector: 'res-research-infrastructure-usage',
    templateUrl: './research-infrastructure-usage.component.html',
    providers: [ProviderManager.getComponentProvider(ResearchInfrastructureUsageComponent)],
} )
export class ResearchInfrastructureUsageComponent implements OnChanges {
    @Input() researchInfrastructureUsages: ResearchInfrastructureUsage[];
    @Input() researchInfrastructureUsageType: GenericValue;
    @Input() hisDdKey: string;
    @Output() researchInfrastructureUsagesChange: EventEmitter<ResearchInfrastructureUsage[]> = new EventEmitter();
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

    public i18nKey = '';
    public relevantUsages: ResearchInfrastructureUsage[] = [];

    public visibility = false;
    public researchInfrastructureUsage: ResearchInfrastructureUsage;
    private editIndexToRemember: number;

    ngOnChanges( changes: SimpleChanges ) {
        if ( changes ) {
            let usageTypeParameter = StringUtils.splitPopWithDot( this.hisDdKey );
            this.i18nKey = usageTypeParameter.charAt( 0 ).toUpperCase() + usageTypeParameter.slice(1);
            this.updateRelevantResearchInfrastructureUsages();
        }
    }

    private updateRelevantResearchInfrastructureUsages() {
        this.relevantUsages = [];
        // console.log('ResearchInfrastructure usages: ' + this.researchInfrastructureUsages.length);
        this.relevantUsages = this.researchInfrastructureUsages.filter(
            ( usage: ResearchInfrastructureUsage ) =>
                usage.researchInfrastructureUsageType.hiskeyId === this.researchInfrastructureUsageType.hiskeyId );
    }

    public addUsage() {
        this.researchInfrastructureUsage = new ResearchInfrastructureUsage();
        this.visibility = true;
    }

    public editUsage( usage: ResearchInfrastructureUsage, index: number ) {
        this.editIndexToRemember = index;
        this.researchInfrastructureUsage = JSON.parse( JSON.stringify( usage ) );
        this.visibility = true;
    }

    public deleteUsage( usage: ResearchInfrastructureUsage ) {
        this.relevantUsages = this.relevantUsages.filter( ( u: ResearchInfrastructureUsage) => u !== usage );
        let index = this.researchInfrastructureUsages.indexOf( usage );
        this.researchInfrastructureUsages.splice( index, 1 );
    }

    public researchInfrastructureUsageChange( event: ResearchInfrastructureUsage ) {
        if( this.editIndexToRemember == null ) {
            this.researchInfrastructureUsages = [...this.researchInfrastructureUsages, event];
        } else {
            let index = this.researchInfrastructureUsages.indexOf(this.relevantUsages[this.editIndexToRemember]);
            this.researchInfrastructureUsages[index] = event;
            this.researchInfrastructureUsages = [...this.researchInfrastructureUsages];
            this.editIndexToRemember = null;
        }
        this.researchInfrastructureUsagesChange.emit(this.researchInfrastructureUsages);
        this.researchInfrastructureUsage = null;
    }
}
